export const PRO_NUMBER = 65;
export const HOT = 50;
export const EQUIPMENT = 100;
export const EQUIPMENT_TYPE = 105;
export const SEALNUMBER = 100;
export const KEY_ACCOUNT = 84;
export const KEY_STAT = 70;
export const AGING = 65;
export const AVAIL_TOP_SHIP = 100;
export const PICKLIST_PRINTED = 100;
export const LOAD_DATE = 80;
export const DOC_CUTOFF = 88;
export const CUTOFF_DATE = 95;
export const DELIVER_TO = 80;
export const REUSE_PRO = 78;
export const PER_DIEM = 85;
export const DATE = 85;
export const WAREHOUSE = 110;
export const MOVE_TYPE = 105;
export const APPOINTMENT_DATE = 120;
export const CHECK_IN_TIME = 120;
export const DOCK_DWELL = 105;
export const SS_LINE = 65;
export const LAST_FREE_DATE = 60;
export const LEG_COUNT = 55;
export const TERMINAL = 85;
export const DATE_EDITABLE = 125;
export const DATE_LONGER = 125;
export const CITY_STATE = 140;
export const DROP_OR_LIVE = 55;
export const POSTAL_CODE = 175;
